import { IMemberTenantInfo } from "./API";

let isDebug = window.location.hostname === 'localhost' || window.location.hostname.endsWith('.ngrok.io') || window.location.href.indexOf('debugManifestsFile=') > -1;

export class MSALConfigGen {
	
	private static msalConfig = {
		auth: {
			debug: false,
			clientId: '7c816beb-102f-49cd-88f7-06085e5df3ac',
			appClientId: '68da843f-2237-497c-8eef-7ada30ce2d21',
			authority: 'https://login.microsoftonline.com/',
			redirectUri: 'https://app.helmsoft.com/',
			autoConsent: false, //This is specifically for the Graph Toolkit components, so they don't go asking for their own consent
		},
		cache: {
			cacheLocation: 'localStorage', // This configures where your cache will be stored
			storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
		},
	};


	public static getActiveTenantId(): string | null {
		return localStorage.getItem('tenantId');
	}

	public static setActiveTenantId(id: string) {
		localStorage.setItem('tenantId', id);
	}

	public static getStoredTenants(): IMemberTenantInfo[] {
		let tenantsJson = localStorage.getItem('tenantInfos');
		if (tenantsJson) {
			return JSON.parse(tenantsJson);
		}
		return [];
	}

	public static setStoredTenants(tenants:IMemberTenantInfo[]) {
		localStorage.setItem('tenantInfos', JSON.stringify(tenants));
	}

	public static getMsalConfig() {

		//Check for tenant ID in local storage
		let tenantId = MSALConfigGen.getActiveTenantId();

		let msalConfig = { ...this.msalConfig };
		if (tenantId) {
			msalConfig.auth.authority = `https://login.microsoftonline.com/${tenantId}`;
		} else {
			msalConfig.auth.authority = 'https://login.microsoftonline.com/common';
		}

		if (isDebug) {
			msalConfig.auth.debug = true;

			msalConfig.auth.clientId = 'af111ed2-e4fb-4936-9c45-01f3be930545';
			msalConfig.auth.appClientId = '7ffe6997-8aa5-48b5-8539-c71701bcd22a';
			msalConfig.auth.redirectUri = 'https://jcardy.ngrok.io/';
			
			apiConfig.scopes = [
				'api://jcardy.ngrok.io/' + msalConfig.auth.clientId + '/.default',
			];
			loginRequest.scopes = [
				'openid',
				'profile',
				'api://jcardy.ngrok.io/' + msalConfig.auth.clientId + '/.default',
			];
			loginRequest.scopesOutsideOfTeams = [
				'openid',
				'profile',
				msalConfig.auth.clientId + '/.default',
			];
		}

		return msalConfig;
	}


}

// Add here the endpoints and scopes for the web API you would like to use.
export const apiConfig = {
	uri: (isDebug ? 'https://jcardy-api.ngrok.io' : 'https://svr-eu.helmsoft.com') + '/api', // e.g. http://localhost:5000/api
	scopes: [
		'api://app.helmsoft.com/7c816beb-102f-49cd-88f7-06085e5df3ac/.default',
	],
	usageUri: (isDebug ? 'https://localhost:44368' : 'https://365automate-usage.azurewebsites.net') + '/api',

	//Default graph scopes. We also ask for a SharePoint scope which gets appended to this.
	defaultGraphScopes: [
		'https://graph.microsoft.com/User.Read',
		'https://graph.microsoft.com/Group.Read.All',
		'https://graph.microsoft.com/User.ReadBasic.All',
	]
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	scopes: [
		'openid',
		'profile',
		'api://app.helmsoft.com/7c816beb-102f-49cd-88f7-06085e5df3ac/.default',
	],
	scopesOutsideOfTeams: [
		'openid',
		'profile',
		'7c816beb-102f-49cd-88f7-06085e5df3ac/.default',
	],
	state: '',
};
